import SectionTitle from "../Common/sectionTitle.component";
import SingleFeature from "./singleFeature.Features";
import featuresData from "./featuresData";

const Features = () => {
  return (
    <>
      <section
        className="bg-primary/[.03] py-16 md:py-20 lg:py-28"
      >
        <div className="container">
          <SectionTitle
            title="Main Features"
            paragraph="Here are the top features that make XplorEase the ultimate virtual assistant platform."
            center
          />

          <div className="grid grid-cols-1 gap-x-8 gap-y-14 md:grid-cols-2 lg:grid-cols-3">
            {featuresData.map((feature, index) => (
              <SingleFeature key={index} feature={feature} />
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Features;
